import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dw2q739g: FaireBrandEntity = {
  token: "b_dw2q739g",
  type: "brand",
  name: "Confident Girls",
  avatarUrl:
    "https://cdn.faire.com/fastly/5ccda6f82a9a3401ff68d2319d415b9e4002548f6a00196b37ba2f47f9fff8fb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/04b0f1f2bd5ef5add48e446c16c22ffac1bce613b88c746fb9ac234c43ff2ac8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5ccda6f82a9a3401ff68d2319d415b9e4002548f6a00196b37ba2f47f9fff8fb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/04b0f1f2bd5ef5add48e446c16c22ffac1bce613b88c746fb9ac234c43ff2ac8.png",
  location: "Stafford, VA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 17,
  isInsider: true,
  description:
    "To be a Confident Girl means that you know who you are and you’re not afraid to show it! We understand that having confidence doesn’t always come easy, so we’re here to help you celebrate everything that makes you unique!\n\n Our collection of bath and body products is made with quality ingredients and an extra dose of love and positivity blended right into each item. We offer a mix of super cool products like lip balms, body washes, and lotions in fun flavors such as Sweet Pineapple, Vanilla, and Lemongrass Citrus - all with beautiful girls just like you in mind. \n\nMore than a line of products, however, Confident Girls is a platform for positive change. Confident Girls was created by 11-year-old kidpreneur, Alex, and her mom. This mommy-daughter team is building a movement to teach young girls about body image and self-worth. They want to change the conversation with young girls about body image and self-worth from the societal message of “mask who you are” to a healthier one of, “love who you are.” ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:33.333Z",
    importedBy: "entity-db-cli",
  },
};
